module.exports = __webpack_public_path__ + "img/avalanche.4a1244ff.png";